// extracted by mini-css-extract-plugin
export default {"js":"Js_js__NA4r+","divs":"Js_divs__XtXJ3"};